<template>
  <v-snackbar v-model="shown" :color="message.color" :timeout="message.timer">
    <AppIcon v-if="message.icon" :icon="message.icon" start /> {{ message.key }}

    <template #actions>
      <CloseBtn icon-color="#fff" @click="shown = false" />
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { isAppError } from '~/helpers/error';
import type { AppError } from '~/types';

interface Message {
  key: string;
  color?: string;
  timer?: number;
  icon?: string;
}

const { t, te } = useI18n();
const DEFAULT_ERROR: AppError = 'server';

defineExpose({ showError, showSuccess, showPrimary, showWarning });

const shown = ref(false);
const message = reactive<Message>({
  key: '',
  color: '',
  icon: ''
});

function show({ key, color, timer, icon }: Message) {
  message.key = te(key) ? t(key) : key;
  message.color = color || 'primary';
  message.timer = timer || 6000;
  message.icon = icon;
  shown.value = true;
}
function showError(key = DEFAULT_ERROR) {
  show({
    key: isAppError(key) ? `errors.${key}` : key,
    color: 'error',
    icon: 'mdi:alert-circle'
  });
}
function showPrimary(key: string) {
  show({ key });
}
function showSuccess(key: string) {
  show({ key, color: 'success', icon: 'mdi:check' });
}
function showWarning(key: string) {
  show({ key, color: 'warning', icon: 'mdi:warning' });
}
</script>